export default __webpack_public_path__ + "static/media/unavailable.13abf58b.jpg";